<template>
  <div>
    <v-container>
      <v-row justify="center">
        <h1>Reset Data</h1>
      </v-row>
    </v-container>
    <v-container>
      <v-row justify="center">
        <p>Already learned how this diary works? Is your diary full of mistakes? Bury the past and start again!</p>
        <p>Your tags and strategies will remain.</p>
      </v-row>
    </v-container>

    <v-container fill-height fluid>
      <v-row align="center" justify="center">
        <v-btn @click="resetDialog = true" x-large class="pa-4 pointer" color="#E62163">
          <v-icon>backspace</v-icon>
          
        
        
        <span class="ml-3">Reset Data</span>
        </v-btn>
      </v-row>
    </v-container>

    <h2>History of resets</h2>

        <div v-for="(reset,index) in resets" :key="reset.id" class="record-card mt-2" >
          <div class="float-left subheadline pt-2 mr-3">
            {{resets.length - index}}.
          </div>
          <div class="float-left">
            <div>{{reset.resetDate | momentTime}}</div>
            <div>{{reset.reason}}</div>
          </div>
        </div>

  
  <v-dialog v-model="resetDialog" max-width="500px">
      <v-card :loading="deleteLoading">
        <v-card-title>
          <span class>
            Are you sure? 
          </span>
        </v-card-title>
        <v-card-text>
          <span class>
            Reason 
          </span>
          <v-select
              v-model="reason"
              :items="reasons"
              background-color="#404855"
              label="Reason"
              solo
              flat
              class="width-full"
            />
            
        </v-card-text>

        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn color="blue darken-1" text @click=" resetDialog = false">No</v-btn>
          <v-btn color="blue darken-1" text @click="resetConfirm">Yes</v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>

  </div>
</template>

<script>
//import createSierraChartKey from "./createSierraChartKey";
var moment = require("moment-timezone");
import { mapGetters } from "vuex";
import axios from "axios";
export default {
  name: "ResetData",
  components: {
    
  },
  data() {
    return {
      reason: "Learning how it works",
      reasons: ["Learning how it works", "Going live", "New start", "Other"],
      resetDialog: false,
      deleteLoading: false
    };
  },
  
  asyncComputed: {
    resets: {
      get() {
        return new Promise((resolve, reject) => {
          axios
            .post("https://tradeinpool.com:3001/api/request/resets/")
            .then(response => {
              resolve(response.data);
            })
            .catch(err => {
              reject(err);
            });
        });
      },
      default: []
    },
  },
  mounted() {},
  computed: {
    ...mapGetters(["username", "timezone"])
  },
  filters:{
    momentTime(value){
      return moment(value).format("l hh:mm")
    }
  },
  methods: {
    resetConfirm() {
      this.deleteLoading = true
      axios
            .post("https://tradeinpool.com:3001/api/remove/tradedata/", {reason: this.reason})
            .then(response => {
              this.resets.unshift(response.data)
              this.deleteLoading = false
              this.resetDialog = false
            })
            .catch(err => {
              alert(err)
              this.deleteLoading = false
              this.resetDialog = false
            });
    }
    
  }
};
</script>

<style scoped>

.lowopa{
  opacity: 0.2;
}
.logodiv{
  min-width:100px;
  height:60px;
  background-color:white;
}
h2 {
  color: #4dbac0;
  font-family: "Roboto", "Roboto Condensed Bold", sans-serif !important;
  font-size: 16px;
}
.record-card {
  width: 100%;
  float: left;
  background-color: #2d3540;
  padding: 13px 15px 15px 15px;
  border-radius: 3px;
  margin-bottom: 1px;
  min-height: 68px;
  cursor: pointer;
  font-size: 12px;
}

.record-card:hover {
  background: #232a35;
}
.tag {
  color: #b6c1cb;
  text-transform: uppercase;
}
.tag-value {
  font-size: 16px;
}
.avatar {
  border: 10px solid #333b47;
}
.platform {
  float: left;
  margin-left: 15px;
  margin-top: 25px;
}
</style>